import type { AgentsClientInterface } from './agentsClient.types';
import BaseClient from '../BaseClient';

export default class GroupAgentsClient extends BaseClient implements AgentsClientInterface {
    constructor(private teamId: number, private groupId: string) {
        super();
    }

    getAgents() {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/get-agents`;
        return this.makeCoreApiRequest(url);
    }
}
